
import Vue from 'vue';
import Dashboard from '@/components/dashboard/Dashboard.vue';

export default Vue.extend({
  components: { Dashboard },
});
